
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCamera as ObiCameraElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-camera.js';
 
 
 

 
 export const ObiCamera = createComponent({
   react: React,
   tagName: 'obi-camera',
   elementClass: ObiCameraElement,
   events: {
     
   }
  });
 
 